import { call, put, takeEvery } from "redux-saga/effects"

// Dashboard Redux States
import { GET_COMPANY_DASHBOARD_STATS } from "./actionTypes"
import {
    getCompanyDashboardStatsSuccess,
    getCompanyDashboardStatsFail,
} from "./actions"

// Include helper Step 1
import { getCompanyDashboardStats } from "../../helpers/fakebackend_helper"

function* fetchCompanyDashboardStats() {
    try {
        const response = yield call(getCompanyDashboardStats)
        yield put(getCompanyDashboardStatsSuccess(response))
    } catch (error) {
        yield put(getCompanyDashboardStatsFail(error))
    }
}

function* dashboardCompanySaga() {
    yield takeEvery(GET_COMPANY_DASHBOARD_STATS, fetchCompanyDashboardStats)
}

export default dashboardCompanySaga
